import { module as Module } from 'modujs';

export default class ProjectAnchors extends Module {
    static INVIEW_CLASS = 'has-project-anchors-inview';

    constructor(m) {
        super(m);

        // UI
        this.$links = this.$('link');
    }

    /* Lifecycle */
    init() {}

    destroy() {
        super.destroy();
    }

    onUpdateIndicator(e) {
        const { target, way } = e;

        if (way === 'enter') {
            this.$links.forEach((link) => {
                const href = link.getAttribute('href');
                if (href === `#${target.id}`) {
                    link.classList.add('is-active');
                } else {
                    link.classList.remove('is-active');
                }
            });
        } else if (way === 'leave') {
            this.$links.forEach((link) => {
                const href = link.getAttribute('href');
                if (href === `#${target.id}`) {
                    link.classList.remove('is-active');
                }
            });
        }
    }

    // =============================================================================
    // Callbacks
    // =============================================================================
    onInview(e) {
        document.documentElement.classList.toggle(ProjectAnchors.INVIEW_CLASS, e.way == 'enter');
    }
}
